var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeftLongToLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 29.45v-18.9c0-.748.602-1.35 1.35-1.35.748 0 1.35.602 1.35 1.35v18.9c0 .748-.602 1.35-1.35 1.35-.748 0-1.35-.602-1.35-1.35zm7.594-8.494a1.344 1.344 0 010-1.907l7.65-7.655A1.35 1.35 0 0119.15 13.3l-5.344 5.343 22.843.006c.748 0 1.35.602 1.35 1.35 0 .748-.602 1.35-1.35 1.35H13.807l5.344 5.344a1.35 1.35 0 01-1.907 1.907l-7.65-7.645z",
    fill: "#fff"
  })));
}
export default SvgArrowLeftLongToLine;